import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'reports.title',
    defaultMessage: 'Reports',
  },
  back: {
    id: 'reports.back',
    defaultMessage: 'Back',
  },
  school: {
    id: 'reports.school',
    defaultMessage: 'School',
  },
  class: {
    id: 'reports.class',
    defaultMessage: 'Class',
  },
  chain: {
    id: 'reports.chain',
    defaultMessage: 'Chain',
  },
  generatePdf: {
    id: 'reports.generatePdf',
    defaultMessage: 'Download PDF',
  },
  see: {
    id: 'reports.see',
    defaultMessage: 'See',
  },
  seeMore: {
    id: 'reports.seeMore',
    defaultMessage: 'See more',
  },
  performanceStudentsComparativeTitle: {
    id: 'reports.performanceStudentsComparativeTitle',
    defaultMessage: 'Comparison of student performance',
  },
  scale: {
    id: 'reports.scale',
    defaultMessage: 'Scale',
  },
  performanceQuestionsComparativeTitle: {
    id: 'reports.performanceQuestionsComparativeTitle',
    defaultMessage: 'Comparison of questions performance',
  },
  schools: {
    id: 'reports.schools',
    defaultMessage: 'Schools',
  },
  of: {
    id: 'reports.of',
    defaultMessage: 'of',
  },
  totalStudents: {
    id: 'reports.totalStudents',
    defaultMessage: 'Total students',
  },
  averageHits: {
    id: 'reports.averageHits',
    defaultMessage: 'Average hits',
  },
  averageErrors: {
    id: 'reports.averageErrors',
    defaultMessage: 'Average errors',
  },
  generalPerformance: {
    id: 'reports.generalPerformance',
    defaultMessage: 'Overall performance',
  },
  generalPerformanceByClass: {
    id: 'reports.generalPerformanceByClass',
    defaultMessage: 'Overall performance by series',
  },
  generalPerformanceByComponent: {
    id: 'reports.generalPerformanceByComponent',
    defaultMessage: 'Overall performance by curriculum component',
  },
  studentsRanking: {
    id: 'reports.studentsRanking',
    defaultMessage: 'Student ranking',
  },
  studentsAZ: {
    id: 'reports.studentsAZ',
    defaultMessage: 'Students',
  },
  hitPercentage: {
    id: 'reports.hitPercentage',
    defaultMessage: 'Percentage of correct answers',
  },
  schoolCriteria: {
    id: 'reports.schoolCriteria',
    defaultMessage: 'School criteria',
  },
  studentsGradeTitle: {
    id: 'reports.studentsGradeTitle',
    defaultMessage: 'Student grades table',
  },
  selectOptionAbove: {
    id: 'reports.selectOptionAbove',
    defaultMessage: 'Select an option above',
  },
  correctAlternative: {
    id: 'reports.correctAlternative',
    defaultMessage: 'Correct Alternative',
  },
  questionDetail: {
    id: 'reports.questionDetail',
    defaultMessage: 'Question Detail',
  },
  question: {
    id: 'reports.question',
    defaultMessage: 'Question',
  },
  commentedResolution: {
    id: 'reports.commentedResolution',
    defaultMessage: 'Commented resolution',
  },
  cognitiveLevel: {
    id: 'reports.cognitiveLevel',
    defaultMessage: 'Cognitive Level',
  },
  ability: {
    id: 'reports.ability',
    defaultMessage: 'Ability',
  },
  percentegaOfChoice: {
    id: 'reports.percentegaOfChoice',
    defaultMessage: 'Percentage of choice',
  },
  alternatives: {
    id: 'reports.alternatives',
    defaultMessage: 'Alternatives',
  },
  alternative: {
    id: 'reports.alternative',
    defaultMessage: 'Alternative',
  },
  analysisOfDistractors: {
    id: 'reports.analysisOfDistractors',
    defaultMessage: 'Analysis of distractors',
  },
  student: {
    id: 'reports.student',
    defaultMessage: 'Student',
  },
  curricularComponent: {
    id: 'reports.curricularComponent',
    defaultMessage: 'Component Curricular',
  },
  hitPercentageComponentsPerQuestion: {
    id: 'reports.hitPercentageComponentsPerQuestion',
    defaultMessage: 'Percentage of correctness of the curricular components per question',
  },
  hitPercentageAbilitiesPerQuestion: {
    id: 'reports.hitPercentageAbilitiesPerQuestion',
    defaultMessage: 'Percentage of correct abilities per question',
  },
  performanceAbilitiesComparativeTitle: {
    id: 'reports.application.details.performanceAbilitiesComparativeTitle',
    defaultMessage: 'Comparison of hits by abilities',
  },
  abilities: {
    id: 'reports.application.details.abilities',
    defaultMessage: 'Abilities',
  },
  description: {
    id: 'reports.application.details.description',
    defaultMessage: 'Description',
  },
  position: {
    id: 'reports.application.details.position',
    defaultMessage: 'Position',
  },
  label: {
    id: 'reports.application.details.label',
    defaultMessage: 'Label',
  },
  hit: {
    id: 'reports.application.CardsLegend.hit',
    defaultMessage: 'Hit',
  },
  error: {
    id: 'reports.application.CardsLegend.error',
    defaultMessage: 'Error',
  },
  didNotAnswer: {
    id: 'reports.application.CardsLegend.didNotAnswer',
    defaultMessage: 'Did not answer',
  },
  canceled: {
    id: 'reports.application.CardsLegend.canceled',
    defaultMessage: 'Canceled',
  },
  omitted: {
    id: 'reports.application.CardsLegend.omitted',
    defaultMessage: 'Omitted',
  },
  area: {
    id: 'reports.application.Label.area',
    defaultMessage: 'Area',
  },
  notebook: {
    id: 'reports.application.PerformanceStudentsComparative.notebook',
    defaultMessage: 'Notebook',
  },
  schoolAverage: {
    id: 'reports.application.Label.schoolAverage',
    defaultMessage: 'School Average',
  },
  generateSheet: {
    id: 'reports.generateSheet',
    defaultMessage: 'Download sheet',
  },
  sheetFilename: {
    id: 'reports.sheetFilename',
    defaultMessage: 'sheet_abilities_question',
  },
  generalAverage: {
    id: 'reports.application.Label.generalAverage',
    defaultMessage: 'General Average',
  },
  average: {
    id: 'reports.application.Label.average',
    defaultMessage: 'Average',
  },
  questionComponent: {
    id: 'reports.application.Label.questionComponent',
    defaultMessage: 'Question/Component',
  },
});
